export const footerConstants = {
  copyRightsText: 'All Rights Reserved',
  companyWebsiteUrl: 'https://www.syrasoft.com',
  poweredByText: 'Powered By',
  maxNavLinksCount: 5,
  termsCountVariantThree: 2,
  socialIconSize: 20,
  facilityLogoHeight: 96,
  facilityLogoWidth: 128,
  copyRightLogoSize: 14,
  poweredByLogo: {
    lightTheme:
      'https://tfw-v11-media-staging.s3.ap-south-1.amazonaws.com/Logo_Syrasoft_1_2c1719e848.svg',
    darkTheme:
      'https://tfw-v11-media-staging.s3.ap-south-1.amazonaws.com/Logo_Syrasoft_2_93d2c90a52.svg',
  },
  socialIconsBgLightTheme: '#d9d9d9',
  socialIconsBgDarkTheme: '#23252e',
  bgColorLightTheme: '#FAFAFA',
  bgColorDarkTheme: '#2A323D',
};
